import { PaccGameDetailResultDto, PaccGameResultRs } from '@domain/rs/phs/pacc/results/PaccGameResultRs';
import { GameFeedbackType } from '@domain/constant/gameFeedbackType';
import { GameType } from '@domain/constant/gameType';

export class PaccGameDetailResultVO {
  type: GameType; // 전략 게임 종류
  unreliableYn: boolean;
  name: string; // 게임 명칭
  description: string;

  constructor(rs: PaccGameDetailResultDto) {
    this.type = rs.type;
    this.unreliableYn = rs.unreliableYn;
    this.name = rs.name;
    this.description = rs.description;
  }
}

export class PaccGameResultVO {
  feedbackType: GameFeedbackType;
  details: PaccGameDetailResultVO[] | null;

  constructor(rs: PaccGameResultRs) {
    this.feedbackType = rs.feedbackType;
    this.details = rs.details?.map((detail) => new PaccGameDetailResultVO(detail));
  }
}
